import { render, staticRenderFns } from "./PivotColorSettingsPanel.vue?vue&type=template&id=2b3d437a&scoped=true"
import script from "./PivotColorSettingsPanel.vue?vue&type=script&lang=js"
export * from "./PivotColorSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./PivotColorSettingsPanel.vue?vue&type=style&index=0&id=2b3d437a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d437a",
  null
  
)

export default component.exports